import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { IDefaultResponse } from "../../models/DefaultResponse";
import { CustomerSettingQueryKeys } from "./keys";
import { ICustomerSetting } from "../../models/CustomerSettings/CustomerSetting";

export default function useCustomerSettings(customerId: string) {
  const { get } = useApiHelper();

  const customerSettings = useQuery({
    queryKey: CustomerSettingQueryKeys.all(customerId),
    queryFn: () =>
      get<IDefaultResponse<ICustomerSetting[]>>(
        `/customer/${customerId}/settings`
      ).then((res) => res.data),
  });

  return {
    customerSettings,
  };
}
